// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\PilotJobOrderDetails\PilotJobOrderDetailsBillingViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DraftChargeCollection, DraftChargeCollectionData, DraftChargeCollectionOptions } from 'data/models/DraftChargeCollection';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// PilotJobOrderDetailsBillingData is the class that PilotJobOrderDetailsBilling serializes to/from
export interface PilotJobOrderDetailsBillingData {
    Id : number;
	
    DraftCharges : DraftChargeCollectionData | null;
    PilotJobOrder : PilotJobOrderData | null;
	
    LastExportDate : /* ISO8601 */ string | null;
}

// PilotJobOrderDetailsBillingOptions is the class which may be passed to the PilotJobOrderDetailsBilling constructor to define optional initial data values
export interface PilotJobOrderDetailsBillingOptions {
    Id : number;
	
    DraftCharges? : DraftChargeCollectionOptions | null;
    PilotJobOrder? : PilotJobOrderOptions | null;
	
    LastExportDate? : /* ISO8601 */ string | null;
}

export class PilotJobOrderDetailsBilling {
    public Id : DataSignal<number>;
	
    public DraftCharges : DataSignal<DraftChargeCollection | null>;
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
	
    public LastExportDate : DataSignal<TZDate | null>;

    constructor();
    constructor(data : PilotJobOrderDetailsBillingOptions);
    constructor(data: PilotJobOrderDetailsBillingOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.DraftCharges = S.value<DraftChargeCollection | null>(null);
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
	    
        this.LastExportDate = jsonableObservable(S.value<TZDate | null>(data && data.LastExportDate !== undefined ? data.LastExportDate === null ? null : new TZDate(data.LastExportDate) : null, TZDate.nullableEq));
    }

    static key(obj : PilotJobOrderDetailsBilling) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotJobOrderDetailsBillingOptions) {
        return obj.Id;
    }

    static update(obj : PilotJobOrderDetailsBilling, data : PilotJobOrderDetailsBillingOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.LastExportDate !== undefined) obj.LastExportDate(data.LastExportDate === null ? null : new TZDate(data.LastExportDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrderDetailsBilling.ts